import * as t from 'io-ts';

export interface PaymentMethodRequirementRequest {
    accountId: string;
    productId: string;
    level?: string;
    resourceIds: string[];
}

export interface PaymentMethodRequirement {
    paymentMethodRequired: boolean;
}

export const ApiPaymentMethodRequirementCodec = t.type({
    payment_method_required: t.boolean,
});

export type ApiPaymentMethodRequirement = t.TypeOf<typeof ApiPaymentMethodRequirementCodec>;
